

import { motion } from 'framer-motion'

const animations = {
    initial: { opacity: 0, },
    animate: { opacity: 1, },
    exit: { opacity: 0, },
}


export default function AnimateWrapper({ children }) {
    return (
        <motion.div className='product'
            variants={animations}
            initial='initial'
            animate='animate'
            exit='exit'
            transition={{ duration: 1 }}
        >
            {children}
        </motion.div>
    )
}
